__turbopack_context__.v({
  "actionsWrapper": "callToAction-module-scss-module__Q65WUq__actionsWrapper",
  "section": "callToAction-module-scss-module__Q65WUq__section",
});
